import { Language } from "store/slices/language-slice";

interface OTPMessage {
  title: string;
  subtitle: Function;
  backDesktop: string;
  backMobile: string;
  otpMessage: string;
}
interface Messages {
  [key: string]: OTPMessage;
}

type Message = {
  [key in Language]: Messages;
};

const messages: Message = {
  en: {
    SMS: {
      title: 'Confirm withdrawal',
      subtitle: (number: string) =>
        `Enter the OTP we’ve sent via sms to ${number}`,
      backDesktop: '← Back',
      backMobile: '←',
      otpMessage: 'Enter verification code',
    },
    EMAIL: {
      title: 'Confirm withdrawal',
      subtitle: (email: string) =>
        `Enter the OTP we’ve sent via email to ${email}`,
      backDesktop: '← Back',
      backMobile: '←',
      otpMessage: 'Email OTP',
    },
  },
};

export default messages;
